(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rubnic-keychain-design-upload"] && !Shopify.designMode) return;
  try {
    if (!window.rubnicGuidedUploadInstalled) {
  window.rubnicGuidedUploadInstalled = true;
  const previews = new WeakMap();
  const clearPreview = fields => {
    const old = previews.get(fields);
    if (old) URL.revokeObjectURL(old);
    previews.delete(fields);
    fields.querySelector('[data-rubnic-upload-image]').removeAttribute('src');
    fields.querySelector('[data-rubnic-upload-preview]').hidden = true;
  };
  const validateFile = (input, fields) => {
    const file = input.files[0];
    const error = fields.querySelector('[data-rubnic-design-error]');
    input.setCustomValidity('');
    error.hidden = true;
    let message = '';
    if (file && file.size > 10 * 1024 * 1024) message = error.dataset.sizeMessage;
    else if (file && (!/\.(jpe?g|png)$/i.test(file.name) || !['image/jpeg', 'image/png'].includes(file.type))) message = error.dataset.typeMessage;
    if (message) {
      input.setCustomValidity(message);
      error.textContent = message;
      error.hidden = false;
      return false;
    }
    return true;
  };
  document.addEventListener('change', event => {
    if (!(event.target instanceof HTMLInputElement)) return;
    const fields = event.target.closest('[data-rubnic-design-fields]');
    if (!fields || event.target.type !== 'file') return;
    clearPreview(fields);
    if (!validateFile(event.target, fields)) return;
    const file = event.target.files[0];
    if (!file) return;
    const url = URL.createObjectURL(file);
    previews.set(fields, url);
    const img = fields.querySelector('[data-rubnic-upload-image]');
    img.src = url;
    fields.querySelector('[data-rubnic-upload-filename]').textContent = file.name;
    fields.querySelector('[data-rubnic-upload-preview]').hidden = false;
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-rubnic-upload-remove]');
    if (!button) return;
    const fields = button.closest('[data-rubnic-design-fields]');
    const input = fields.querySelector('input[type=file]');
    input.value = '';
    input.setCustomValidity('');
    fields.querySelector('[data-rubnic-design-error]').hidden = true;
    clearPreview(fields);
    input.focus();
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const fields = form.querySelector('[data-rubnic-design-fields]');
    if (!fields) return;
    event.stopImmediatePropagation();
    const input = fields.querySelector('input[type=file]');
    if (!validateFile(input, fields) || !form.reportValidity()) {
      event.preventDefault();
      input.reportValidity();
      return;
    }
    form.enctype = 'multipart/form-data';
  }, true);
}
  } catch(e) { console.error(e); }
})();

})();
